import { isMonthYearDateValid } from '../../utils/validation';
import { MONTH_FIELD, YEAR_FIELD, TYPE_UK_ADDRESS, DATE_MOVE_SUFFIX } from '../../utils/constants';
import moment from 'moment';

export const dateMoveRequired = (allValues, type, currentIndex, formValues) => {
  const date = {
    monthField: allValues ? allValues[`${type}${MONTH_FIELD}`] : '',
    yearField: allValues ? allValues[`${type}${YEAR_FIELD}`] : ''
  };

  if (isMonthYearDateValid(date) && isValidDate(date, formValues, currentIndex)) {
    return undefined;
  }
  return 'Required';
};

const isValidDate = (currentDate, formValues, currentIndex) => {
  if (currentIndex && currentIndex !== 0) {
    const datePrefix = `${TYPE_UK_ADDRESS}${currentIndex === 1 ? '' : currentIndex - 1}`;
    const previousData = {
      monthField: formValues
        ? formValues[`${datePrefix}${DATE_MOVE_SUFFIX}`][`${datePrefix}${MONTH_FIELD}`]
        : '',
      yearField: formValues
        ? formValues[`${datePrefix}${DATE_MOVE_SUFFIX}`][`${datePrefix}${YEAR_FIELD}`]
        : ''
    };
    return validateAddressHistory(currentDate, previousData);
  }
  return true;
};

export const validateAddressHistory = (date, previousDate) => {
  const now = moment(`01-${date.monthField}-${date.yearField}`, 'DD-MM-YYYY');
  const previous = moment(`01-${previousDate.monthField}-${previousDate.yearField}`, 'DD-MM-YYYY');
  const duration = moment.duration(previous.diff(now));
  return duration._milliseconds > 0;
};
